import { pathOr } from 'ramda';
import * as React from 'react';

import { EParkingType } from '../../../types/jsonQuery';
import { NonEmptyArray } from '../../../../../JsonQuery';
import { useContext } from '../../../utils/useContext';
import { Parking } from '../../../components/advancedFilters/Parking';

export const ParkingContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  let parkingType = pathOr<EParkingType[] | null>(null, ['parking_type', 'value'], jsonQuery);
  if (parkingType && parkingType.length === 0) {
    parkingType = null;
  }

  const handleChange = React.useCallback(
    (parkingType: EParkingType[] | null) => {
      onChange({ action: 'setParkingType', arguments: [parkingType] });
    },
    [onChange],
  );

  return <Parking value={parkingType as NonEmptyArray<EParkingType> | null} onChange={handleChange} />;
};
